import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import { Coupon } from 'commons/models/coupon';
import { EMPTY_ARRAY, EMPTY_OBJECT } from 'commons-ui';

import { UserlistData, TYPE_OPTIONS, ALLOWED_PAYMENT_MODES_OPTIONS, MAX_REDEMPTIONS_PER_PERSON_CLOSED_COUPON } from './constants';

export const hydrateFormData = (data: any) => {
	const { segmentsInclusive: segmentsInclusiveStr, segmentsExclusive: segmentsExclusiveStr } = data;
	const allowedPaymentModesIds = _map(ALLOWED_PAYMENT_MODES_OPTIONS, (option) => option.id);
	// const allowedPlatformsIds = _map(ALLOWED_PLATFORMS_OPTIONS, (option) => option.id);
	const typeIds = _map(TYPE_OPTIONS, (option) => option.id);

	const segmentsInclusive = segmentsInclusiveStr ? segmentsInclusiveStr.join(',') : '';
	const segmentsExclusive = segmentsExclusiveStr ? segmentsExclusiveStr.join(',') : '';

	const hydratedData = {
		...data,
		conversions: _map(
			Object.entries(_get(data, 'conversions', EMPTY_OBJECT)),
			([amount, conversion]: [amount: any, conversion: any]) => {
				const formConversion: any = { amount };
				_forEach(Object.entries(conversion), ([key, value]: [key: any, value: any]) => {
					formConversion[key] = parseInt(value, 10);
				});

				return formConversion;
			}
		),
		allowedPaymentModes: _filter(_get(data, 'allowedPaymentModes', EMPTY_ARRAY), (paymentMode) =>
			_includes(allowedPaymentModesIds, paymentMode)
		),
		// allowedPlatforms: _filter(_get(data, 'allowedPlatforms', EMPTY_ARRAY), (platform) =>
		// 	_includes(allowedPlatformsIds, platform)
		// ),
		segmentsInclusive,
		segmentsExclusive,
		isCouponSegmented: segmentsInclusive.length > 0 || segmentsExclusive.length > 0,
		type: _includes(typeIds, _get(data, 'type')) ? _get(data, 'type') : undefined,
		isOpen: !_get(data, 'isOpen', true)
	};

	if (_has(hydratedData, 'id')) {
		delete hydratedData.id;
	}

	return hydratedData;
};

export const dehydrateFormData = (data: any): { couponData: Coupon; userListData?: UserlistData } => {
	const {
		conversions: formConversions,
		maxConversionPerRedemption,
		allowUnlimitedRedemptions,
		allowUnlimitedRedemptionsPerPerson,
		isCouponSegmented
	} = data;
	const conversions: any = {};

	_forEach(formConversions, (formConversion) => {
		const { amount } = formConversion;
		const conversion = { ...formConversion };
		delete conversion.amount;

		conversions[amount] = { bonusCoins: '0f', tickets: '0f' };

		_forEach(Object.entries(conversion), ([key, value]) => {
			conversions[amount][key] = `${value}f`;
		});
	});

	const userlist = _get(data, 'userlist', '');
	const uids = _map(userlist.split(','), (user) => Number(user));

	const segmentsInclusive = isCouponSegmented
		? _filter(
				_map(_get(data, 'segmentsInclusive', '').split(','), (segment) => segment.trim()),
				(seg) => seg.length > 0
		  )
		: [];
	const segmentsExclusive = isCouponSegmented
		? _filter(
				_map(_get(data, 'segmentsExclusive', '').split(','), (segment) => segment.trim()),
				(seg) => seg.length > 0
		  )
		: [];

	let maxRedemptions = _get(data, 'maxRedemptions');
	if (allowUnlimitedRedemptions) {
		maxRedemptions = Number.MAX_SAFE_INTEGER;
	}

	let maxRedemptionsPerPerson = _get(data, 'maxRedemptionsPerPerson');
	if (allowUnlimitedRedemptionsPerPerson) {
		maxRedemptionsPerPerson = maxRedemptions;
	}

	const isOpen = !_get(data, 'isOpen');

	const couponData = {
		...data,
		conversions,
		maxRedemptions,
		maxRedemptionsPerPerson: isOpen ? maxRedemptionsPerPerson : MAX_REDEMPTIONS_PER_PERSON_CLOSED_COUPON,
		isOpen,
		sortOrder: _get(data, 'sortOrder', Number.MAX_SAFE_INTEGER),
		segmentsInclusive,
		segmentsExclusive,
		maxConversionPerRedemption: { bonusCoins: 0, tickets: 0, ...maxConversionPerRedemption }
	};

	delete couponData.userlist;
	delete couponData.allowUnlimitedRedemptions;
	delete couponData.allowUnlimitedRedemptionsPerPerson;
	delete couponData.isCouponSegmented;

	return {
		couponData,
		...(!isOpen &&
			uids &&
			uids.length > 0 && { userListData: { code: couponData.code, uids, maxRedemptions: maxRedemptionsPerPerson } })
	};
};
